import React from "react";

const StyledATag = ({ to, children }) => {
  return (
    <a className="text-red-700 hover:text-red-500 text-sm" href={to}>
      {children}
    </a>
  );
};

export default StyledATag;
